import React from "react";
import AddActionButton from "./AddActionButton";
import DeleteEdgeButton from "./DeleteEdgeButton";
import { useReactFlow } from "@xyflow/react";

const EdgeButtonsContainer = ({
  edgeId,
  target,
  labelX,
  labelY,
  isHovered,
  onMouseEnter,
  onMouseLeave,
}) => {
  const reactFlowInstance = useReactFlow();

  // Check if the target node is an exit node
  const targetNode = reactFlowInstance.getNode(target);
  const isExitNode = targetNode?.type === "exitNode";

  return (
    <div
      style={{
        position: "absolute",
        transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
        pointerEvents: "all",
        display: "flex",
        gap: "4px",
        alignItems: "center",
        opacity: isHovered ? 1 : 0,
        transition: "opacity 0.2s",
      }}
      className="nodrag nopan step"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {/* Only show Add button if target is NOT an exit node */}
      {!isExitNode && <AddActionButton edgeId={edgeId} />}
      <DeleteEdgeButton edgeId={edgeId} target={target} />
    </div>
  );
};

export default EdgeButtonsContainer;
